'use client';

import { Card } from '@/modules/players/v3/components/shared/card/card';
import { PlayerDashboardEmptyContent } from '@/modules/players/v3/components/shared/dashboard-widget-card/player-dashboard-empty-content';
import { DASHBOARD_ILLUSTRATION } from '@/modules/players/v3/constants/dashboard-illustrations';

interface MascotEmptyStateProps {
  title: string;
  description: string;
}

export function MascotEmptyState({ title, description }: MascotEmptyStateProps) {
  return (
    <Card className='group bg-white relative overflow-hidden min-h-[280px] border border-gray-200 transition-[box-shadow,border-color] duration-200 ease-out md:hover:border-gray-300 md:hover:shadow-md motion-reduce:transition-none motion-reduce:md:hover:border-gray-200 motion-reduce:md:hover:shadow-sm'>
      <PlayerDashboardEmptyContent
        title={title}
        description={description}
        visual={{
          kind: 'mascot',
          src: DASHBOARD_ILLUSTRATION.MASCOT_RUNNING_PADDLE,
          position: 'bottom-right',
        }}
        className='py-10'
      />
    </Card>
  );
}
